<form nz-form [formGroup]="FG" class="form">
    <nz-form-item>
        <nz-form-control [ngSwitch]="country">
            <nz-input-group
                *ngSwitchCase="'CA'"
                style="
                    background-color: #fff;
                    padding: 4px;
                    border-radius: 3px;
                    border: 1px solid #d9d9d9;
                "
            >
                <nz-input-number
                    #dayInput
                    tabindex="0"
                    formControlName="day"
                    nzPlaceHolder="DD"
                    [nzMin]="1"
                    [nzMax]="31"
                    [nzStep]="1"
                    nzSize="small"
                    [nzParser]="$any(dayParser)"
                    style="max-width: 30%"
                >
                </nz-input-number>
                <span style="max-width: 2%">/</span>

                <nz-input-number
                    #monthInput
                    tabindex="1"
                    formControlName="month"
                    nzPlaceHolder="MM"
                    [nzMin]="1"
                    [nzMax]="12"
                    [nzStep]="1"
                    nzSize="small"
                    [nzParser]="$any(monthParser)"
                    style="max-width: 30%"
                >
                </nz-input-number>
                <span style="max-width: 2%">/</span>
                <nz-input-number
                    #yearInput
                    tabindex="2"
                    formControlName="year"
                    nzPlaceHolder="YYYY"
                    [nzStep]="1"
                    nzSize="small"
                    [nzMin]="1900"
                    [nzMax]="2100"
                    [nzParser]="$any(yearParser)"
                    style="max-width: 30%"
                    borderless
                >
                </nz-input-number>
            </nz-input-group>
            <nz-input-group
                *ngSwitchCase="'US'"
                style="
                    background-color: #fff;
                    padding: 4px;
                    border-radius: 3px;
                    border: 1px solid #d9d9d9;
                "
            >
                <nz-input-number
                    #monthInput
                    tabindex="0"
                    formControlName="month"
                    nzPlaceHolder="MM"
                    [nzMin]="1"
                    [nzMax]="12"
                    [nzStep]="1"
                    nzSize="small"
                    [nzParser]="$any(monthParser)"
                    style="max-width: 30%"
                >
                </nz-input-number>
                <span style="max-width: 2%">/</span>
                <nz-input-number
                    #dayInput
                    tabindex="1"
                    formControlName="day"
                    nzPlaceHolder="DD"
                    [nzMin]="1"
                    [nzMax]="31"
                    [nzStep]="1"
                    nzSize="small"
                    [nzParser]="$any(dayParser)"
                    style="max-width: 30%"
                >
                </nz-input-number>
                <span style="max-width: 2%">/</span>
                <nz-input-number
                    #yearInput
                    tabindex="2"
                    formControlName="year"
                    nzPlaceHolder="YYYY"
                    [nzStep]="1"
                    nzSize="small"
                    [nzMin]="1900"
                    [nzMax]="2100"
                    [nzParser]="$any(yearParser)"
                    style="max-width: 30%"
                    borderless
                >
                </nz-input-number>
            </nz-input-group>
        </nz-form-control>
    </nz-form-item>
</form>
